<div fxLayout="column" fxLayoutAlign="center center">
    <img [attr.src]="Photo" [alt]="altText">
    <input #fileInput hidden type="file" (change)="updateModel()" [name]="name" [id]="name" attr.telemetry="Edit-Photo"
           [accept]="allowedTypes">
    <command-bar fxLayout="row" fxLayoutAlign="center start" [commands]="commands" [dense]="dense"></command-bar>
</div>